/**
 * Nom / HTML de description des packs services souvent fournis en français par l'API
 * alors que la langue d'affichage est pilotée par le voyageur. On applique des
 * remplacements de fragments connus puis loc() sur des clés anglaises (fr_FR / autres bundles).
 */

const PACK_DISPLAY_NAME_FR_TO_EN_KEY = {
  "Pack Confort TV": "TV Comfort Pack"
}

/** Ordre : chaînes les plus longues en premier pour éviter les remplacements partiels */
const DESCRIPTION_FRAGMENTS_FR_TO_EN_KEY = [
  {
    fr: "Lire les conditions générales de location longue durée et de services TV",
    enKey: "Read the general terms of long-term rental and TV services"
  },
  {
    fr: "Renouvellement anticipé à partir du 24ème loyer",
    enKey: "Early renewal from the 24th rental instalment"
  },
  {
    fr: "Livraison à domicile",
    enKey: "Home delivery"
  },
  {
    fr: "Garantie Panne",
    enKey: "Breakdown warranty"
  },
  {
    fr: "Reprise à domicile",
    enKey: "Home pickup (trade-in)"
  }
]

/**
 * @param {string} [name]
 * @param {(key: string) => string} loc
 */
export function translateServicePackDisplayName(name, loc) {
  if (!name || typeof name !== "string") return name
  const enKey = PACK_DISPLAY_NAME_FR_TO_EN_KEY[name]
  return enKey ? loc(enKey) : loc(name)
}

/**
 * @param {string} [html]
 * @param {(key: string) => string} loc
 */
export function translateServicePackDescriptionHtml(html, loc) {
  if (!html || typeof html !== "string") return html
  let out = html
  for (const { fr, enKey } of DESCRIPTION_FRAGMENTS_FR_TO_EN_KEY) {
    if (out.includes(fr)) {
      out = out.split(fr).join(loc(enKey))
    }
  }
  return out
}
